import { fetchWrapper } from '../../../services/fetchServices/fetchWrapper';

export type UpdateOrganization = {
  name: string;
  noHardwareMaintenance: boolean;
};

export const emptyOrganization: UpdateOrganization = {
  name: '',
  noHardwareMaintenance: false,
};

export function updateOrganization(id: number, organization: UpdateOrganization) {
  return fetchWrapper({
    url: `/api/organization/${id}`,
    fetchArg: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: organization,
    },
  });
}
